import React from 'react';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelAgenciesContainer = styled.div`
    font-weight: ${(props) => (props.$isBold ? 'bold' : 'normal')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    text-transform: uppercase;

    .icon-container {
        width: 0.75rem;
        text-align: center;
    }

    p {
        margin: 0;
    }
`;
const ModelDetailsHeaderAgencies = ({ model, readOnly }) => {
    const viewModelAgencies = useUserPermission(
        'ViewModelAgencies',
        (model?.Users || model?.U || []).map((user) => user.UserID)
    );

    return (
        <PermissionBlock
            content={
                model.MotherAgencyID || model.MAID ? (
                    <ModelAgenciesContainer>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['globe']} />
                        </div>
                        <p>{model.MotherAgencyName || model.MAN}</p>
                    </ModelAgenciesContainer>
                ) : model.Represented || model.R ? (
                    <ModelAgenciesContainer $isBold>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['medal']} />
                        </div>
                        <p>represented</p>
                    </ModelAgenciesContainer>
                ) : (
                    <ModelAgenciesContainer>
                        <div className="icon-container">
                            <NwIcon icon={byPrefixAndName.fasl['globe']} />
                        </div>
                        <p>no mother ag.</p>
                    </ModelAgenciesContainer>
                )
            }
            permission={viewModelAgencies}
        />
    );
};

export default ModelDetailsHeaderAgencies;
